/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Testimonial_3_RoleInputs */

const en_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior Parent`)
};

const es_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padre/madre de junior`)
};

const de_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junioren-Elternteil`)
};

const zh_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`青少年家长`)
};

const ar_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ولي أمر ناشئ`)
};

const fr_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parent de junior`)
};

const vi_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phụ huynh junior`)
};

const sw_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mzazi wa junior`)
};

const th_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ปกครองจูเนียร์`)
};

const bs_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roditelj juniora`)
};

const ja_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジュニアゴルファーの保護者`)
};

const ko_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`학부모`)
};

const pt_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mãe de jogador júnior`)
};

const it_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior Parent`)
};

const sv_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior förälder`)
};

const nl_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juniorouder`)
};

const da_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior Parent`)
};

const nb_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foreldre`)
};

const fi_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior vanhempi`)
};

const pl_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rodzic juniora`)
};

const ru_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Родитель юного игрока`)
};

const tr_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior Ebeveyn`)
};

const hi_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जूनियर खिलाड़ी के अभिभावक`)
};

const id_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orang tua pemain junior`)
};

const ms_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ibu bapa pemain junior`)
};

const cs_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rodič juniorského hráče`)
};

const el_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Νεότερος Γονέας`)
};

const he_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הורים`)
};

const af_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juniorouder`)
};

const hu_home_testimonial_3_role = /** @type {(inputs: Home_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior Szülő`)
};

/**
* | output |
* | --- |
* | "Junior Parent" |
*
* @param {Home_Testimonial_3_RoleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_testimonial_3_role = /** @type {((inputs?: Home_Testimonial_3_RoleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Testimonial_3_RoleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_testimonial_3_role(inputs)
	if (locale === "de") return de_home_testimonial_3_role(inputs)
	if (locale === "zh") return zh_home_testimonial_3_role(inputs)
	if (locale === "ar") return ar_home_testimonial_3_role(inputs)
	if (locale === "fr") return fr_home_testimonial_3_role(inputs)
	if (locale === "vi") return vi_home_testimonial_3_role(inputs)
	if (locale === "sw") return sw_home_testimonial_3_role(inputs)
	if (locale === "th") return th_home_testimonial_3_role(inputs)
	if (locale === "bs") return bs_home_testimonial_3_role(inputs)
	if (locale === "ja") return ja_home_testimonial_3_role(inputs)
	if (locale === "ko") return ko_home_testimonial_3_role(inputs)
	if (locale === "pt") return pt_home_testimonial_3_role(inputs)
	if (locale === "it") return it_home_testimonial_3_role(inputs)
	if (locale === "sv") return sv_home_testimonial_3_role(inputs)
	if (locale === "nl") return nl_home_testimonial_3_role(inputs)
	if (locale === "da") return da_home_testimonial_3_role(inputs)
	if (locale === "nb") return nb_home_testimonial_3_role(inputs)
	if (locale === "fi") return fi_home_testimonial_3_role(inputs)
	if (locale === "pl") return pl_home_testimonial_3_role(inputs)
	if (locale === "ru") return ru_home_testimonial_3_role(inputs)
	if (locale === "tr") return tr_home_testimonial_3_role(inputs)
	if (locale === "hi") return hi_home_testimonial_3_role(inputs)
	if (locale === "id") return id_home_testimonial_3_role(inputs)
	if (locale === "ms") return ms_home_testimonial_3_role(inputs)
	if (locale === "cs") return cs_home_testimonial_3_role(inputs)
	if (locale === "el") return el_home_testimonial_3_role(inputs)
	if (locale === "he") return he_home_testimonial_3_role(inputs)
	if (locale === "af") return af_home_testimonial_3_role(inputs)
	if (locale === "hu") return hu_home_testimonial_3_role(inputs)
	return en_home_testimonial_3_role(inputs)
});